import { render, staticRenderFns } from "./UserStatistics.vue?vue&type=template&id=6a65d3d8"
import script from "./UserStatistics.vue?vue&type=script&lang=js"
export * from "./UserStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports